import packageInfo from '../../../package.json';

export function logAppVersion(): void {
    console.log(`App version: ${packageInfo.version}`);
}